import type {
  AhaEditorV2Controller,
  EditorPlugin,
  InitHandler,
} from '@aha-app/aha-editor-v2';

const SetEditorControllerPlugin = ({
  setController,
}: {
  setController: (controller: AhaEditorV2Controller) => void;
}): EditorPlugin => {
  const onInit: InitHandler = ahaEditor => {
    setController(ahaEditor.controller);
  };

  return {
    name: 'Set editor controller plugin',
    handlers: {
      onInit,
    },
  };
};

export default SetEditorControllerPlugin;
